import React, { useEffect, useState } from "react";
import { IconDownload, IconX } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { MButton } from "@/components/ui/atoms/MButtons";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";

const DISMISSED_KEY = "maatra_install_banner_dismissed";

const MInstallAppBanner: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { canInstall, isStandalone, isIos, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === "true"
  );

  useEffect(() => {
    if (canInstall)
      setDismissed(localStorage.getItem(DISMISSED_KEY) === "true");
  }, [canInstall]);

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "true");
    setDismissed(true);
  };

  if (searchParams.get("install") !== "1") return null;
  if (isStandalone || dismissed) return null;
  if (!canInstall && !isIos) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[1000] flex items-center gap-3 bg-[#481E9A] px-4 py-3 pt-[calc(12px+env(safe-area-inset-top))] text-white">
      <IconDownload size={22} className="shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold leading-tight">
          {t("common.installApp.title")}
        </p>
        <p className="text-xs leading-tight text-white/80">
          {isIos && !canInstall
            ? t("common.installApp.iosDescription")
            : t("common.installApp.description")}
        </p>
      </div>
      {canInstall && (
        <MButton
          variant="filled"
          size="sm"
          text={t("common.install")}
          className="shrink-0 !bg-white !text-[#481E9A]"
          onClick={promptInstall}
        />
      )}
      <button
        type="button"
        aria-label={t("common.close")}
        onClick={handleDismiss}
        className="shrink-0 touch-manipulation"
      >
        <IconX size={18} />
      </button>
    </div>
  );
};

export default MInstallAppBanner;
